import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgs/banner.jpg'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "navbar" }
const _hoisted_4 = { class: "nav-items" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.current = 'Home'))
        }, "DESAFIO-FÍSICA"),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "nav-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.current = 'Content'))
          }, "CONTEÚDO"),
          _createElementVNode("span", {
            class: "nav-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.current = 'Contact'))
          }, "CONTATO")
        ])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("main", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.current))),
      _createVNode(_component_Footer)
    ])
  ]))
}